<div *ngIf="allocation$ | async as allocation">
    <section class="liste">

        <div *ngIf="isAllocationTypeArticle">
            <span><strong>Article :</strong></span>
            <span>{{allocation.ArticleModele.LibelleProduit}} - {{allocation.ArticleModele.Libelle}}</span>
        </div>

        <div *ngIf="allocation.IdAnneeRef" class="line-date-reference">
            <span><strong>Année de référence : </strong></span>
            <span>{{getReferenceYearLabel(allocation.IdAnneeRef)}}</span>
        </div>

        <div *ngIf="isAllocationTypeVirtualWallet else allocationTypeTemplate">
            <span><strong>Porte-monnaie virtuel :</strong></span>
            <span>{{getVirtualWalletLabel(allocation.IdComptePMVAbondement)}}</span>
        </div>

        <ng-template #allocationTypeTemplate>
            <div>
                <span><strong>Type d'attribution : </strong></span>
                <span>{{allocation.IsNominative ? 'Nominative' : 'Pour toute la famille'}}</span>
            </div>
        </ng-template>

        <div *ngIf="allocation.DateValeurDefaut && (isAllocationTypeArticle || isAllocationTypeVirtualWallet)">
            <span><strong>Date valeur :</strong></span>
            <span>{{allocation.DateValeurDefaut | date: 'dd/MM/YYYY'}}</span>
        </div>


        <ng-container *ngIf="allocation.IsMasquee && displayHideAllocation">

            <div>
                <kal-icon class="gup-U-color--green"><i class="material-icons"> check</i></kal-icon>
                Masquer l'attribution pour le bénéficiaire jusqu'au&nbsp;<strong>{{allocation.DateEvenement | date: 'dd/MM/YYYY'}}</strong>
            </div>

        </ng-container>

        <ng-container *ngIf="isAllocationTypeVirtualWallet">
            <div>
                <span><strong>Journal :</strong></span>
                <span>{{getJournalLabel(allocation.IdJournalAbondement)}}</span>
            </div>
            <div>
                <span><strong>Compte charge :</strong></span>
                <span>{{getAccountLabel(allocation.IdCompteChargeAbondement)}}</span>
            </div>

        </ng-container>

        <div *ngIf="allocation.Description && (isAllocationTypeArticle || isAllocationTypeVirtualWallet)">
            <span><strong>Description :</strong></span>
            <span>{{allocation.Description}}</span>
        </div>

        <div *ngIf="allocation.ListeClesRepartition?.CleRepartitionModelDTO | arrayNotEmpty">
            <span><strong>Plan analytique :</strong></span>
            <ul>
                <li *ngFor="let model of allocation.ListeClesRepartition.CleRepartitionModelDTO">
                    {{model| repartitionKeyLabel:(analyticalPlansAndSections$ | async)}}
                </li>
            </ul>
        </div>

        <div *ngIf="isAutomaticAllocation">
            <kal-icon>
                done
            </kal-icon>
            <span><strong>Exécution automatique</strong></span>
        </div>

        <div *ngIf="!!beneficiariesConcernedCount">
            <span><strong>Nombre de bénéficiaires concernés : </strong></span>
            <span>{{beneficiariesConcernedCount}}</span>
        </div>

    </section>

    <section *ngIf="!!allocation.AttribTgExec && !!allocation.DateDernierMAJ"
             class="maj">
        <div>
            <span><strong>Date de dernière exécution : </strong></span>
            <span>{{allocation.DateDernierMAJ | date: 'dd/MM/yyyy'}}</span>
        </div>
    </section>

</div>
